<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let selectedLists = [];
  let maxPins = 3;
  let listsSlotsRemaining = maxPins;
  $: selectedLists;
  $: listsSlotsRemaining = maxPins - selectedLists.length;
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-lists {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      color: #717171;
      margin-bottom: 16px;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    .list-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      max-width: 400px;
      margin: 20px auto 24px;
    }

    .list-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border: 1px dashed var(--neutral-input-gray, #c6c6c6);
      text-align: left;
      border-radius: 20px;
      cursor: pointer;
      gap: 16px;

      &.selected {
        cursor: default;
        border-style: solid;

        &:hover {
          background: none;
        }
      }

      &:hover {
        background: #f1f1f1;
      }

      .img-placeholder,
      .list-image-empty,
      .list-image {
        display: flex;
        background: #f1f1f1;
        min-width: 100px;
        width: 100px;
        aspect-ratio: 1/1;
        border-radius: 12px;
        object-fit: cover;
        transition: 200ms;
      }

      .img-placeholder {
        border: 2px solid #e3e3e3;
      }

      .list-image-empty {
        background: #f9f7ff;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:hover {
        .img-placeholder {
          background: darken(#f1f1f1, 4%);
        }
      }

      .list-meta {
        flex: 1;
        overflow: hidden;
      }

      .list-title {
        font-weight: 500;
      }

      .list-description {
        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #7f7f7f;
      }

      .icon__add,
      .icon__remove {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        background-color: #000;
        top: 20px;
        right: 20px;
        border: 2px solid #e3e3e3;
        cursor: pointer;
        transition: 200ms;
        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }

      .icon__remove {
        background-color: transparent;
        border-color: transparent;
        &:hover {
          background-color: #f1f1f1;
        }
      }
    }
  }
</style>

<div class="creator-spotlight-lists" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Pinned Lists</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>
  <p class="ui-subtitle">Pin up to 3</p>
  <div class="list-container">
    {#each selectedLists as list}
      <div class="list-item selected">
        {#if list.minified_cover_image}
          <img alt="Cover image" src={list.minified_cover_image} class="list-image" />
        {:else if list.cover_photos.length > 0}
          <img src={list.cover_photos[0].url} class="list-image" alt="Cover image" />
        {:else}
          <div class="list-image-empty">
            <img src="/emojis/purple_star.png" alt="star emoji" style="width: 48px; height: 48px;" />
          </div>
        {/if}
        <div class="list-meta">
          <div class="list-title">{list.name}</div>
          <div class="list-description">{list.description}</div>
        </div>
        <div class="icon__remove" on:click={() => dispatch('delete', list.id)}>
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
              fill="#1C1C1C" />
          </svg>
        </div>
      </div>
    {/each}
    {#each Array(listsSlotsRemaining) as _}
      <div
        class="list-item"
        on:click={() => {
          dispatch('goToListsSelector');
        }}>
        <div class="img-placeholder"></div>
        <div class="list-meta"></div>
        <div class="icon__add">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.25 9.18799V15.5H8.75V9.18799H15V7.68799H8.75V1.5H7.25V7.68799H1V9.18799H7.25Z"
              fill="white" />
          </svg>
        </div>
      </div>
    {/each}
  </div>

  <div class="finished-btn">
    <Button
      disabled={selectedLists.length < 1}
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={'Finish'}
      on:click={() => {
        dispatch('finish');
      }} />
  </div>
</div>
